@for (item of items(); track item) {
  <div
    class="highlight"
    [innerHTML]="item"
  ></div>
}
